import { Log } from "@/interfaces/Log";
import { PaginatedResponse } from "@/interfaces/paginatedResponse";
import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";
import { ref } from "vue";

interface Props {
  immediate?: boolean;
  params: Params;
}

interface Params {
  id: string | number;
  page?: number;
}

const getLogHotel = async (params: Params) => {
  const { data } = await axios.get<PaginatedResponse<Log>>(
    `/api/internal/hotels/${params.id}/logs?page=${params.page}`,
  );

  return data;
};

const useHotelLog = (props: Props) => {
  const { immediate, params } = props;
  const page = ref<string | number>(1);

  const { data, isLoading, refetch } = useQuery(
    ["hotel"],
    () => getLogHotel({ id: params.id!, page: Number(page.value!) }),
    {
      enabled: immediate,
    },
  );

  const setPage = (newPage: number | string) => {
    page.value = newPage;
  };

  return { data, isLoading, page, setPage, refetch };
};

export default useHotelLog;
